import React, { useState } from "react";
import { AppListing } from "../../../../components/appListing";
import { FaCircle } from "react-icons/fa6";
import { FaComments } from "react-icons/fa";
import moment from "moment";
import MainPageDialog from "../../../../components/mainPageDialog";

const CareplanProblems = ({ listData = [], loading = false }) => {
  const [commentsDialog, setCommentsDialog] = useState(false);
  const [commentsText, setCommentsText] = useState("");

  const handleComments = (item) => {
    setCommentsText(item?.comments);
    setCommentsDialog(true);
  };

  const problemCols = [
    {
      title: "Problem",
      key: "icd_code_name",
      getData: (item) =>
        item?.icd_code_name ? (
          <span className="text-black text-sm flex flex-row gap-x-2">
            <FaCircle className="text-orange-500 mt-1 w-[10px] h-[10px] min-w-[10px] min-h-[10px]" />
            {item?.icd_code_name} - {item?.icd_short_desc}
          </span>
        ) : (
          "-"
        ),
    },
    { title: "Chronicity", key: "occurrence_title" },
    { title: "Status", key: "outcome_title" },
    { title: "Severity", key: "severity_title" },
    {
      title: "Onset",
      key: "onset",
      getData: (data) => {
        const originalDate =
          data?.onset !== "" ? moment(data?.onset).format("l") : "";
        return originalDate;
      },
    },
    {
      title: "Comments",
      key: "history",
      colClass: "col-md-1 text-center",
      getData: (item) =>
        item?.comments !== "" && (
          <div className="flex w-[100%] items-start justify-start px-2 text-blue-500 text-lg hover:text-blue-900">
            <FaComments />
          </div>
        ),
      onClick: (item) => handleComments(item),
    },
  ];

  return (
    <>
      <div className="py-2">
        <AppListing
          loading={loading}
          listData={listData}
          cols={problemCols}
        />
      </div>
      {commentsDialog && (
        <MainPageDialog
          title="Comments"
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () => setCommentsDialog(false),
            },
          ]}
          onCancelHandler={() => setCommentsDialog(false)}
        >
          {commentsText === "" ? "No comments added." : commentsText}
        </MainPageDialog>
      )}
    </>
  );
};

export default CareplanProblems;
